module.exports = __webpack_public_path__ + "b6f01ddafa77d1515f4b1186f640bb84.png";